module.exports = __webpack_public_path__ + "img/3.84b7d909.jpg";